import React, { useState, useEffect } from 'react'

import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'

import {
    hideSupplementalMediaView,
    setMediaViewList,
    setSelectedMediaIdx,
} from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import { forceMediaPause } from 'aria-viewer/interactive-element/actions/common.js'
import { MEDIA_TYPES, NETWORK_TYPES } from 'aria-viewer/tour/constants'

import MediaViewer from '../../components/MediaViewer'
import Photoviewer from '../../components/Photoviewer'
import InstagramViewer from '../../components/InstagramViewer'
import Videoviewer from '../../components/Videoviewer'
import Panoviewer from '../../components/Panoviewer'

import styles from './styles'

const renderViewer = (mediaType, media, selectedIdx, changePanoFullScreen, { owner_id, loc_id }) => {
    if (media[selectedIdx]?.network === NETWORK_TYPES.instagram) {
        return (
            <InstagramViewer
                media={media[selectedIdx]}
                inst_id={owner_id}
                loc_id={loc_id}
                showDescription={true}
                showTitle={true}
            />
        )
    }
    switch (mediaType) {
        case MEDIA_TYPES.photo:
            return <Photoviewer media={media} selectedIdx={selectedIdx} inst_id={owner_id} loc_id={loc_id} />
        case MEDIA_TYPES.video:
            return <Videoviewer media={media} selectedIdx={selectedIdx} inst_id={owner_id} loc_id={loc_id} />
        case MEDIA_TYPES.panorama:
            return (
                <Panoviewer
                    media={media}
                    selectedIdx={selectedIdx}
                    changePanoFullScreen={changePanoFullScreen}
                    inst_id={owner_id}
                    loc_id={loc_id}
                />
            )
        default:
            return <Photoviewer media={media} selectedIdx={selectedIdx} inst_id={owner_id} loc_id={loc_id} />
    }
}

const MediaViewerContainer = props => {
    const {
        stopId,
        mediaViewer,
        showMediaViewer,
        supplementalMedia,
        mediaStopId,
        classes,
        supplementalMediaVisible,
        hideSupplementalMediaView,
        supplementalSelectedMediaType,
        mediaListByType: { photos, panoramas, videos },
        location,
        mediaViewList,
        setMediaViewList,
        selectedMediaIdx,
        setSelectedMediaIdx,
    } = props

    const [display, setDisplay] = useState(false)
    const [fullScreen, changePanoFullScreen] = useState(false)

    const [errorIdx, setErrorIdx] = useState([])

    useEffect(() => {
        setDisplay(true)
    }, [selectedMediaIdx])

    useEffect(() => {
        if (errorIdx.length > 0) setMediaViewList(mediaViewList.filter(elem => !errorIdx.includes(elem.id)))
    }, [errorIdx])

    useEffect(() => {
        if (supplementalMediaVisible) {
            let panos = panoramas.map(pano => {
                return { ...pano, fullScreen: false, play: true }
            })
            if (supplementalSelectedMediaType === 'photo') setMediaViewList([...photos, ...videos, ...panos])
            else if (supplementalSelectedMediaType === 'video') setMediaViewList([...videos, ...photos, ...panos])
            else if (supplementalSelectedMediaType === 'pano') setMediaViewList([...panos, ...photos, ...videos])
            else setMediaViewList([...photos, ...videos, ...panos])
        } else {
            setMediaViewList(null)
        }
    }, [supplementalMediaVisible])

    return mediaViewList && supplementalMediaVisible ? (
        <div style={{ position: 'relative', zIndex: '10000' }}>
            <MediaViewer
                media={mediaViewList}
                showMediaViewer={showMediaViewer}
                selectedIdx={selectedMediaIdx}
                setIdx={setSelectedMediaIdx}
                fullScreen={fullScreen}
                hideSupplementalMediaView={hideSupplementalMediaView}
                supplementalMediaVisible={supplementalMediaVisible}
                errorIdx={errorIdx}
                setErrorIdx={setErrorIdx}
            >
                {renderViewer(
                    mediaViewList[selectedMediaIdx]?.mediaType,
                    mediaViewList,
                    selectedMediaIdx,
                    changePanoFullScreen,
                    location
                )}
            </MediaViewer>
        </div>
    ) : null
}

export default compose(
    connect(
        mapSelectorsToProps([
            'location',
            'currentStop',
            'mediaListByType',
            'supplementalSelectedMediaType',
            'supplementalMediaVisible',
            'tourid',
            'mediaViewList',
            'selectedMediaIdx',
        ]),
        {
            hideSupplementalMediaView,
            forceMediaPause,
            setMediaViewList,
            setSelectedMediaIdx,
        }
    ),
    injectSheet(styles)
)(MediaViewerContainer)
